import { cloneDeep } from "lodash";
import Spec from "./Spec";
import { SpecManager } from "./SpecManager";

export default class SpecValue extends Spec {
    private userValue: string | number | boolean = null;

    constructor(key: string, specManager: SpecManager, readonly: boolean) {
        super(specManager, key, readonly);
        this.toUpdate = true;
        // if (value !== undefined) {
        //     this.value = value
        // }
    }

    set value(value) {
        if (this.readonly) {
            // debugger
            return;
        }
        if (value === undefined) {
            debugger;
        }
        if (this.userValue !== value) {
            this.userValue = value;
            this.onModified();
        }
    }

    get value() {
        return this.userValue;
    }

    // get displayValue() {
    //     return this.value
    // }

    get toBeIncludedInTheBundle() {
        return true;
    }

    build() {}

    setStream(stream: { userValue: string | number | boolean }) {
        this.userValue = stream.userValue;
    }

    getStreamValue() {
        return { userValue: this.userValue };
    }

    resetOriginalValue() {
        debugger;
    }

    get isUserValue(): boolean {
        return true;
    }
}
